export enum FeatureFlags {
  ApplicationsList = 'merchant-admin-applications-list',
}